import { Injectable } from "@angular/core";
import { EzoomApiProvider } from "./ezoom-api";
/*
  Generated class for the MeusTreinosProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MeusTreinosProvider {
    constructor(public api: EzoomApiProvider) {}

    update(training): Promise<any> {
        return new Promise((resolve, reject) => {
            this.api
                .post("meus_treinos/updateTreino", { info: training })
                .subscribe({
                    next: (res) => {
                        resolve(res);
                    },
                    error: (err) => {
                        reject(err);
                    },
                });
        });
    }

    getTreinos(user): Promise<any> {
        return new Promise((resolve, reject) => {
            this.api
                .post("meus_treinos/treinos", {
                    associado: user.id,
                    sequencia: user.sequency,
                })
                .subscribe({
                    next: (res) => {
                        resolve(res);
                    },
                    error: (err) => {
                        reject(err);
                    },
                });
        });
    }

    getHistorico(user): Promise<any> {
        return new Promise((resolve, reject) => {
            this.api
                .post("meus_treinos/getHistorico", {
                    associado: user.id,
                    sequencia: user.sequency,
                })
                .subscribe({
                    next: (res) => {
                        resolve(res);
                    },
                    error: (err) => {
                        reject(err);
                    },
                });
        });
    }

    registreHistorico(
        associado: string,
        sequency: string,
        id_training: string,
        startTime: any,
        endTime: any
    ) {
        return new Promise((resolve, reject) => {
            this.api
                .post("meus_treinos/historico", {
                    associado: associado,
                    sequencia: sequency,
                    id_training: id_training,
                    start: startTime,
                    end: endTime,
                })
                .subscribe((response: any) => {
                    if (response.status) {
                        resolve(response.message);
                    } else {
                        reject(response.message);
                    }
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/meus-treinos.ts